import { apiRequest } from "@/services/api-client";
import { CreateItemDeckInput, CreateItemDeckOutput, WebAppRoutes } from "types/web-app";

export const createItemDeck = (input: CreateItemDeckInput) =>
  apiRequest<CreateItemDeckOutput>("/" + WebAppRoutes.CREATE_ITEM_DECK, {
    method: "POST",
    body: JSON.stringify(input),
  });
